module.exports = __webpack_public_path__ + "media/images/backward-link-arrow-fc6cd25972cc9a58d37c3ea9d682c294.svg";